import { ACTION_TYPES } from '../../constants/store.constants';

const initialState = {
  imageIdDescriptionMap: {},
  selectedImages: [],
  imageUploadStatusMap: {},
  displayUploadErrorNotification: false,
  displayPartialErrorNotification: false,
  imageIdBeingEdited: null,
  disableImageListInteraction: false
};

const MediaReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.UPDATE_IMAGE_DESCRIPTION: {
      const { imageId, description } = action.payload;
      const selectedImage = state.selectedImages.find(image => image.fileId === imageId);
      if (selectedImage) {
        selectedImage.description = description;
      }
      return {
        ...state,
        imageIdDescriptionMap: {
          ...state.imageIdDescriptionMap,
          [imageId]: description
        },
        selectedImages: [...state.selectedImages]
      };
    }
    case ACTION_TYPES.ADD_SELECTED_IMAGE: {
      const newImage = action.payload;
      return {
        ...state,
        selectedImages: [...state.selectedImages, newImage]
      };
    }
    case ACTION_TYPES.REMOVE_SELECTED_IMAGE: {
      const imageIdToRemove = action.payload;
      return {
        ...state,
        selectedImages: state.selectedImages.filter(image => image.fileId !== imageIdToRemove)
      };
    }
    case ACTION_TYPES.CLEAR_SELECTED_IMAGES: {
      return {
        ...state,
        selectedImages: []
      };
    }
    case ACTION_TYPES.UPDATE_IMAGE_STATUS: {
      return {
        ...state,
        imageUploadStatusMap: {
          ...state.imageUploadStatusMap,
          ...action.payload
        }
      };
    }
    case ACTION_TYPES.RESET_IMAGE_STATUS: {
      return {
        ...state,
        imageUploadStatusMap: {}
      };
    }
    case ACTION_TYPES.SET_DISPLAY_UPLOAD_SERVICE_ERROR_NOTIFICATION: {
      return {
        ...state,
        displayUploadErrorNotification: action.payload
      };
    }
    case ACTION_TYPES.SET_DISPLAY_PARTIAL_ERROR_NOTIFICATION: {
      return {
        ...state,
        displayPartialErrorNotification: action.payload
      };
    }
    case ACTION_TYPES.SET_IMAGEID_BEING_EDITED: {
      return {
        ...state,
        imageIdBeingEdited: action.payload
      };
    }
    case ACTION_TYPES.DISABLE_IMAGE_LIST_INTERACTION: {
      return {
        ...state,
        disableImageListInteraction: action.payload
      };
    }
    default:
      return state;
  }
};

export default MediaReducer;
